export const VISITOR = 'VISITOR';
export const CARD_REGISTRATION = 'CARD_REGISTRATION';
